import {Link} from "react-router-dom";

const FooterLogin = () => {
  return (
    <div className="bg-[#19295C] w-full hidden flex-col justify-center items-center z-20 sticky -bottom-[0px] py-2 mt-auto max-[992px]:!flex ">
      <ul className="social-icons align-bottom ">
        <li>
          <Link to={"https://www.facebook.com/helpclic"} target="_blank">
            <i className="fa fa-facebook "></i>
          </Link>
        </li>
        <li>
          <Link to={"https://www.instagram.com/help.clic/"} target="_blank">
            {" "}
            <i className="fa fa-instagram"></i>
          </Link>
        </li>
        <li>
          <Link
            to={"https://www.linkedin.com/company/help-clic/"}
            target="_blank"
          >
            {" "}
            <i className="fa fa-linkedin"></i>
          </Link>
        </li>
        <li>
          <Link to={"https://www.youtube.com/@Help-clic"} target="_blank">
            {" "}
            <i className="fa fa-youtube-play" aria-hidden="true"></i>
          </Link>
        </li>
        <li>
          <Link to={"https://www.tiktok.com/@help.clic"} target="_blank">
            <i className="fi fi-brands-tik-tok"></i>
          </Link>
        </li>
      </ul>
      <Link
        to="/politique-de-confidentialite"
        className="mt-1 text-sm font-medium text-white underline underline-offset-2 hover:text-white"
      >
        Politique de confidentialité
      </Link>
    </div>
  );
};
export default FooterLogin;
